import { LocalStorageKeys } from '@/constants/enums/LocalStorageEnum';
import type { IBullet } from '@/models/interface/bullet';
import isMobile from 'is-mobile';

let isMobileFlag: boolean = isMobile({ tablet: true });

export const useAppStore = defineStore(
  'app',
  () => {
    const isMobile = ref<boolean | null>(null); //是否為手機
    const device = ref<string>(''); //pc或mobile
    const mobileType = ref<string>(''); //手機類型
    const isLoading = ref<boolean>(false); //是否正在loading
    const isShowEvent = ref(false); // 是否顯示推廣活動
    const adImageSrc = ref<string>(''); // 推廣活動圖片
    const isBulletOpen = ref(false); // 是否開啟佈告欄
    const isTelemarketingQuestionnaireOpen = ref(false); // 是否開啟電銷問卷
    const bulletContent = ref<IBullet[]>([]); // 佈告欄資料
    const settingHomePage = ref<string>('calendar'); //預設首頁為行事曆
    const isShowBeginnerGuide = ref(
      localStorage.getItem('showBeginnerGuide')
        ? JSON.parse(localStorage.getItem('showBeginnerGuide')!)
        : true
    ); // 是否顯示初學者指南
    const isLanding = ref(false); //footer跳轉去login頁看(保持登入狀態)
    const isShowSMSVerifyPopup = ref(false);
    const isShowGetCouponPopup = ref(false);
    const isShowGetLiveStreamCouponPopup = ref(false);
    const documentReferrer = ref<string>(''); // 來源網址

    // 行動裝置識別
    const isMobileRef = ref<boolean>(false);

    // 行動裝置 頁面表頭元件顯示狀態
    const showMobilePageHeading = ref<boolean>(true);

    /**
     * 偵測裝置類型
     */
    const detectDevice: () => void = () => {
      if (typeof window !== 'undefined') {
        isMobileRef.value = isMobileFlag;
      }

      isMobileRef.value = window.innerWidth <= 1024;
    };

    /**
     * 初始化裝置偵測
     */
    const initDevice = () => {
      // 避免 SSR 環境
      if (typeof window === 'undefined') return;

      // 初次偵測
      detectDevice();

      // window resize 偵測
      const handler: () => void = () => detectDevice();
      window.addEventListener('resize', handler);

      onBeforeUnmount(() => window.removeEventListener('resize', handler));
    };

    /** 是否為移動裝置寬度 */
    // const handleGetCurrentDevice = (): void => {
    //     console.log('[handleGetCurrentDevice]');
    //     isMobile.value = window.innerWidth <= 1024;
    // };

    /** 處理裝置 */
    const handleDetectDevice = () => {
      // 用户代理字串
      const userAgent = navigator.userAgent;

      // 是否是手機裝置
      const isMobileDevice = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );

      if (isMobileDevice) {
        device.value = 'mobile';
        if (navigator.userAgent.match(/Android/i)) {
          mobileType.value = 'Android';
        } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
          mobileType.value = 'iOS';
        } else {
          mobileType.value = 'Other';
        }
      } else {
        device.value = 'pc';
      }
    };

    onMounted(initDevice);

    return {
      isMobileState: isMobileRef,
      isMobile, //是否為手機
      device, //pc或mobile
      mobileType, //手機類型
      isLoading, //是否正在loading
      isShowEvent,
      isBulletOpen,
      isTelemarketingQuestionnaireOpen,
      bulletContent,
      adImageSrc,
      settingHomePage,
      isShowBeginnerGuide,
      isLanding,
      isShowSMSVerifyPopup,
      isShowGetCouponPopup,
      isShowGetLiveStreamCouponPopup,
      documentReferrer,
      showMobilePageHeading,
      handleDetectDevice,
      detectDevice
    };
  },
  {
    persist: {
      key: LocalStorageKeys.AppStore,
      storage: sessionStorage,
      paths: ['documentReferrer']
    }
  }
);
